import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

const SupportHelp = () => {
  // Get authentication token
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  // State management
  const [showForm, setShowForm] = useState(false)
  const [data, setData] = useState([])
  const [files, setFiles] = useState(null)
  const [form, setForm] = useState({
    title: "",
    description: "",
    search: "",
  })

  // Pagination
  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)
  const pagesVisited = pageNumber * listPerPage
  const currentItems = data.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(data.length / listPerPage)

  // Fetch data on component mount
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    axios
      .post(
        URLS.GetHelp,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )
      .then(res => {
        setData(res.data.userRequest || [])
      })
      .catch(error => {
        console.error("Error fetching data:", error)
        toast.error("Failed to fetch data")
      })
  }

  const handleSearch = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))

    if (value.trim() === "") {
      fetchData()
      return
    }

    axios
      .post(
        URLS.GetHelpSearch + value,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )
      .then(res => {
        setData(res.data.userRequest || [])
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        }
      })
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (!file) return

    const validTypes = ["jpg", "jpeg", "png"]
    const fileType = file.name.split(".").pop().toLowerCase()

    if (validTypes.includes(fileType)) {
      setFiles(e.target.files)
    } else {
      e.target.value = null
      toast.error("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    submitForm()
  }

  const submitForm = () => {
    const formData = new FormData()
    formData.append("title", form.title)
    formData.append("description", form.description)
    formData.append("type", "Supplier")

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append("image", files[i])
      }
    }

    axios
      .post(URLS.AddHelp, formData, {
        headers: { Authorization: `Bearer ${TokenData}` },
      })
      .then(res => {
        if (res.status === 200) {
          toast.success(res.data.message)
          setShowForm(false)
          setFiles(null)
          setForm({ title: "", description: "", search: "" })
          fetchData()
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        }
      })
  }

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const toggleForm = () => {
    setShowForm(!showForm)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Support Center"
          />

          <Row>
            <Col md={12}>
              {showForm && (
                <Card className="p-4">
                  <Form onSubmit={handleSubmit}>
                    <h5 className="mb-3">Raise a Support Ticket</h5>
                    <Row>
                      <Col md="6">
                        <Label>
                          Title <span className="text-danger">*</span>
                        </Label>
                        <Input
                          onChange={handleChange}
                          name="title"
                          value={form.title}
                          required
                          type="text"
                          placeholder="Enter Title"
                        />
                      </Col>
                      <Col md="6">
                        <Label>
                          Attach Image{" "}
                          <span className="text-danger">260 * 190</span>
                        </Label>
                        <Input
                          type="file"
                          className="form-control"
                          required
                          name="image"
                          onChange={handleFileChange}
                          accept=".jpg,.jpeg,.png"
                        />
                      </Col>
                      <Col md="12" className="mt-3">
                        <Label>
                          Description <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="textarea"
                          className="form-control"
                          name="description"
                          value={form.description}
                          required
                          rows={3}
                          placeholder="Enter Description"
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        onClick={toggleForm}
                        color="danger m-1 btn-sm"
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button type="submit" color="info text-white m-1 btn-sm" >
                        Submit <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              )}
            </Col>

            <Col md={12}>
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Button color="primary" onClick={toggleForm} size="sm">
                        Raise a Support Ticket{" "}
                        <i className="bx bx-plus-circle"></i>
                      </Button>
                    </Col>
                    <Col md={6}>
                      <div className="float-end">
                        <Input
                          name="search"
                          value={form.search}
                          onChange={handleSearch}
                          type="search"
                          placeholder="Search..."
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className="table-responsive">
                    <Table hover bordered responsive>
                      <thead>
                        <tr className="text-center">
                          <th>Sl.No</th>
                          <th>Ticket Id</th>
                          <th>Date / Time</th>
                          <th>Title</th>
                          <th>Attach Image</th>
                          <th>Description</th>
                          <th>Reply</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <tr key={item._id} className="text-center">
                              <td>{pagesVisited + index + 1}</td>
                              <td>{item.ticketId}</td>
                              <td>
                                {item.date} - {item.time}
                              </td>
                              <td>{item.title}</td>
                              <td>
                                {item.image && (
                                  <img
                                    src={`${URLS.Base}${item.image}`}
                                    alt="Screenshot"
                                    height="100"
                                    width="80"
                                    className="img-thumbnail"
                                  />
                                )}
                              </td>
                              <td>{item.description}</td>
                              <td>{item.reply || "-"}</td>
                              <td>
                                <b
                                  className={`text-${
                                    item.status === "pending"
                                      ? "warning"
                                      : "success"
                                  }`}
                                >
                                  {item.status}
                                </b>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>

                    {pageCount > 1 && (
                      <div className="d-flex justify-content-end mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                        />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </React.Fragment>
  )
}

export default SupportHelp
